import React, { useEffect } from "react";
import {
  Box,
  Select,
  MenuItem,
  TextField,
  Button,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useAppContext } from "../../context/AppContext";

const DataFilter = ({ onRefresh }) => {
  const { deviceId, setDeviceId, date, setDate, devices, setDevices } =
    useAppContext();

  useEffect(() => {
    const savedDevices = JSON.parse(localStorage.getItem("devices")) || [];
    setDevices(savedDevices);

    const savedDeviceId = localStorage.getItem("selectedDeviceID");
    if (savedDeviceId) {
      setDeviceId(savedDeviceId);
    } else if (savedDevices.length > 0) {
      // If nothing is saved, default to first device
      setDeviceId(savedDevices[0]);
      localStorage.setItem("selectedDeviceID", savedDevices[0]);
    }
  }, []);

  const handleSubmit = () => {
    console.log("Option:", deviceId);
    console.log("Date:", date);
  };

  const handleSelectOption = (e) => {
    const value = e.target.value;
    setDeviceId(value);
    localStorage.setItem("selectedDeviceID", value);
  };

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      gap={2}
      sx={{ p: 1, flexWrap: "wrap" }}
    >
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel>Select Device ID</InputLabel>
        <Select
          value={deviceId}
          label="Select Device ID"
          onChange={handleSelectOption}
        >
          {devices.map((id, index) => (
            <MenuItem key={index} value={id}>
              {id}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        size="small"
        label="Select Date"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={date}
        onChange={(e) => setDate(e.target.value)}  sx={{ minWidth: 200 }}
      />
      <Button variant="contained" onClick={onRefresh}>
        Refresh
      </Button>
    </Box>
  );
};

export default DataFilter;
